import { z } from "zod";

const dayAvailability = z.object({
  enabled: z.boolean().default(false),
  am: z.boolean().default(false),
  pm: z.boolean().default(false),
});

export const availabilitySchema = z.object({
  anytime: z.boolean().default(false),
  monday: dayAvailability,
  tuesday: dayAvailability,
  wednesday: dayAvailability,
  thursday: dayAvailability,
  friday: dayAvailability,
});

export type AvailabilityFormType = z.infer<typeof availabilitySchema>;
export type DayAvailabilityType = z.infer<typeof dayAvailability>;
